import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { Formik } from "formik";

import CustomNavbar from "../../components/CustomNavbar";
//import SidebarDashboard from '../../components/SidebarDashboard';
import CustomTable from "../../components/CustomTable";
import {
  getVaccines,
  saveVaccines,
  editVaccines,
  deleteVaccines,
  resetVaccines,
} from "../../redux/vaccines/actions";
import { getLabs } from "../../redux/laboratories/actions";
import messages from "../../redux/messages";
import SidebarConfig from "../../components/SidebarConfig";
import moment from "moment";
import CustomPagint from "../../components/CustomPagint";

const Vaccines = (props) => {
  const schema = Yup.object().shape({
    nombre: Yup.string().ensure().required("**Campo requerido"),
    // .test(
    //   "codigo-format",
    //   "**Solo admite letras",
    //   (value) => {
    //     // Lógica de temporizador para la validación
    //     if (value === "" || !value) {
    //       return true; // Campo vacío, no validamos todavía
    //     }

    //     if (value.length < 1) {
    //       return true; // No validamos hasta que se escriban al menos 1 caracter
    //     }

    //     // Aquí puedes definir tu patrón personalizado
    //     const pattern = /[A-Za-zñÑáéíóúÁÉÍÓÚ0-9_-\s]+/;
    //     return pattern.test(value);
    //   }
    // ),
    laboratorio: Yup.string().ensure().required("**Campo requerido"),
    covid: Yup.boolean().notRequired(""),
  });

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  //const [loadingType, setLoadingType] = useState('initial');
  // const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();

  const { vacs, vacsLength, loading, saveLoading, formError, vacsError } =
    useSelector((store) => store.vaccines);
  const pages = Math.ceil(vacsLength / limit);

  //laboratories
  const { labs, loading: labsloading } = useSelector((store) => store.labs);

  //seleccion del checkbox
  const [isChecked, setIsChecked] = useState(false);

  const columns = [
    {
      Header: "Nombre",
      accessor: "nombre",
    },
    {
      Header: "Casa / laboratorio",
      accessor: "laboratorio_list[0].nombre",
    },
    {
      Header: "Es vacuna COVID-19?",
      accessor: (d) => {
        return d.covid ? "Si" : "No";
      },
    },
    {
      id: "fecha",
      Header: "Ultima actualización",
      Filter: "",
      Cell: (value) => moment(value.row.original.fecha).format("DD/MM/YYYY"),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  // Métodos
  const getAVaccines = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getVaccines(
        {
          offset: offs,
          limit: lim,
          filter: filt,
        },
        parseInt(props.match.params.type)
      )
    );

  useEffect(() => {
    getAVaccines();
  }, [props.match.params.type]);

  useEffect(() => {
    dispatch(getLabs({ itype: parseInt(props.match.params.type) }));
  }, [dispatch, props.match.params.type]);

  const addVac = () => {
    dispatch(resetVaccines());
    setShowModal(true);
    setEdit(false);
    //setLoadingType('modal');
    // setValidated(false);
  };

  const onEdit = (item, index) => {
    dispatch(resetVaccines());
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    //setLoadingType('modal');
    // setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getAVaccines(oOffset, limit, e.target.filter.value);
  };

  const onSubmitLabs = (req) => {
    // e.preventDefault();
    // const form = e.currentTarget;
    // if (form.checkValidity() === false) {
    //   setValidated(true);
    //   return;
    // }

    // const req = {
    //   nombre: e.target.nombre.value,
    //   fecha: moment(new Date()).format("YYYY-MM-DD"),
    //   laboratorio: e.target.laboratorio.value,
    //   covid: isChecked,
    // };

    req.fecha = moment(new Date()).format("YYYY-MM-DD");
    if (!edit) {
      dispatch(
        saveVaccines(req, parseInt(props.match.params.type), setShowModal)
      );
      // e.target.reset();
      // setShowModal(false);
    } else {
      dispatch(
        editVaccines(
          req,
          editItem.id,
          index,
          parseInt(props.match.params.type),
          setShowModal
        )
      );
      // setShowModal(false);
    }
  };

  const handleOnChange = () => {
    setIsChecked(!isChecked);
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getAVaccines(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteVaccines(id, index));
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">
              {parseInt(props.match.params.type) === 1
                ? "Vacunas formal"
                : "Vacunas funcional"}
            </h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                {/* <Col xs="auto">
                  <Form.Control
                  onChange={ e => setFilter(e.target.value)}
                  placeholder="Buscar"
                  className="rounded-pill form-control-sm"
                  type="search"></Form.Control>
                </Col> */}
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => addVac()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {!!vacsError && !loading && (
            <Alert variant="danger" className="m-2">
              {vacsError}
            </Alert>
          )}
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : vacsLength > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={vacs} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={vacsLength}
                pages={pages}
                pagFunc={getAVaccines}
              />
            </>
          ) : (
            <>
              {vacsError === "" && (
                <Alert variant="info" className="my-4">
                  Aún no hay vacunas registradas, comienza agregando algunas
                </Alert>
              )}
            </>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmitLabs}
          initialValues={{
            nombre: edit ? editItem.nombre : "",
            laboratorio: edit
              ? editItem.laboratorio
              : labs.length === 0
              ? ""
              : labs[0].id,
            covid: edit ? editItem.covid : false,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title>
                  {edit ? "Editar vacuna" : "Crear vacuna"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="mt-1 mb-2">
                    {formError}
                  </Alert>
                )}
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Nombre de vacuna
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      id="nombre"
                      name="nombre"
                      isInvalid={touched.nombre && errors.nombre}
                      isValid={touched.nombre && !errors.nombre}
                      onBlur={handleBlur("nombre")}
                      onChange={handleChange}
                      value={values.nombre}
                      className="rounded-pill"
                      type="text"
                      placeholder="Nombre de vacuna"
                      // pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9_-\s]+"
                      //pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+$"
                    ></Form.Control>
                    {touched.nombre && errors.nombre && (
                      // <div>
                      <small className="mx-2 text-danger">
                        {errors.nombre}
                      </small>
                      // </div>
                    )}
                    {/* <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Solo admite letras
                    </Form.Control.Feedback> */}
                  </Col>
                </Form.Group>
                {/* <Form.Group as={Row} className="mb-3">
              <Form.Label 
                column 
                sm="12"
                md="4">Fecha de la dósis</Form.Label>
              <Col 
                sm="12"
                md="8">
                <Form.Control
                  name="fecha"
                  className="rounded-pill"
                  required
                  type="date"
                  defaultValue={ edit ? editItem.fecha : null}
                  placeholder="Fecha"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Col>
            </Form.Group> */}
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Laboratorio / casa
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Row className="align-items-center">
                      <Col sm={labsloading ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          id="laboratorio"
                          name="laboratorio"
                          isInvalid={touched.laboratorio && errors.laboratorio}
                          isValid={touched.laboratorio && !errors.laboratorio}
                          onBlur={handleBlur("laboratorio")}
                          onChange={handleChange}
                          value={values.laboratorio}
                          className="rounded-pill"
                        >
                          {labs.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.nombre}
                            </option>
                          ))}
                        </Form.Control>
                        {touched.laboratorio && errors.laboratorio && (
                          // <div>
                          <small className="mx-2 text-danger">
                            {errors.laboratorio}
                          </small>
                          // </div>
                        )}
                        {/* <Form.Control.Feedback type="invalid">
                          **Campo requerido
                        </Form.Control.Feedback> */}
                      </Col>
                      {labsloading && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Form.Group>
                <Form.Group className="mb-3" controlId="covid">
                  <Form.Check
                    id="covid"
                    name="covid"
                    isInvalid={touched.covid && errors.covid}
                    isValid={touched.covid && !errors.covid}
                    onBlur={handleBlur("covid")}
                    onChange={(e) => {
                      setFieldValue("covid", e.target.checked);
                    }}
                    value={values.covid}
                    // className="rounded-pill"
                    // type="switch"
                    defaultChecked={edit ? editItem.covid : null}
                    label="Es COVID-19?"
                  />
                  <Form.Control.Feedback type="invalid">
                    **Campo requerido
                  </Form.Control.Feedback>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoading}
                  variant="primary"
                  type="submit"
                >
                  {saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default Vaccines;
